import React from "react";

function Itsupport() {
  return (
    <>
      <section className="services" id="itsupport">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-md-12">
              <div className="title text-center ">
                <h2>Our Services</h2>
              </div>
              <h3>
                <b className="text-color">IT Support Services</b>
              </h3>

              <b>
                THE COST OF CYBERSECURITY CRIMES WILL BE 6 TRILLION DOLLARS BY
                THE END OF 2021.
              </b>

              <p>
                <b>
                  Macrozion Techsystem offers a broad range of IT infrastructure
                  support services to assure the high stability and performance
                  of your applications in cloud, on-premise, and hybrid
                  environments. Our following services will help you build
                  robust and secure cyber enterprises.{" "}
                </b>
              </p>
            </div>

            <div className="col-md-12">
              <h5>
                <b> 1. </b>
                NETWORK SUPPORT
              </h5>
              <p>
                Our network support services are developed to help you optimize
                the value of your IT investments. We provide life cycle
                management, network security and monitoring services, network
                design, strategy, integration, and implementation services that
                help prevent the risk of future issues.
              </p>
              <h5>
                <b> 2. </b>
                APPLICATION AND DATABASE MANAGEMENT
              </h5>
              <p>
                We will help you overcome the challenges experienced dting the
                application deployment through services such as application and
                database management, middleware services, database
                administration and management, and open-source solution and
                management.
              </p>
              <h5>
                <b> 3. </b>
                SERVER SUPPORT
              </h5>
              <p>
                Our experts can help you improve the reliability and performance
                of servers through a wide range of server support services,
                including server upgrades, installations, and configurations.
              </p>

              <h5>
                <b> 4. </b>
                INFRASTRUCTURE SECURITY AND MODERNIZATION
              </h5>
              <p>
                A secure IT infrastructure is essential for the growth of any
                organization and we understand it better. Since the inception,
                we have helped clients to build robust infrastructure by
                performing vulnerability scans, AES/SSL encryption, monitoring
                data integrity, scanning server for issues, and so on. In
                addition to this, we can regularly update your OS, third-party
                software, and security software.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Itsupport;
